'use client';

import React from 'react';
import { FieldError, FieldErrors, get } from 'react-hook-form';
import styles from './FieldError.module.scss';
import { FieldProperties, FieldType } from '@/services/formSchema.service';
import classNames from 'classnames';

interface FieldErrorProps {
    errors?: FieldErrors<any>;
    fieldName: string;
}

export const FieldErrorComponent: React.FC<FieldErrorProps> = ({ errors, fieldName }) => {
    if (!errors) {
        return null;
    }

    const errorMessage = (get(errors, fieldName) as FieldError)?.message;

    return (
        <div id="errorWrapper" className={classNames(styles.errorWrapper)}>
            {errorMessage}
        </div>
    );
};
